<template>
    <div>
        <!-- 价格 / 余额 提示 -->
        <div class="pay-balance-bar">
            <span class="pay-balance-item">
                <span class="pay-balance-label">{{ $t('common.pay_price_label') }}</span>
                <span class="pay-balance-value">{{ readList.coin }}</span>
                <img src="../../assets/images/bookbean_icon.png" class="pay-balance-icon"/>
            </span>
            <span class="pay-balance-divider">|</span>
            <span class="pay-balance-item" :class="welfareConfig.coin < readList.coin ? 'pay-balance-item--low' : ''">
                <span class="pay-balance-label">{{ $t('common.pay_balance_label') }}</span>
                <span class="pay-balance-value">{{ welfareConfig.coin || 0 }}</span>
                <img src="../../assets/images/bookbean_icon.png" class="pay-balance-icon"/>
            </span>
        </div>

        <!-- 赚积分任务 — 顶部 -->
        <div class="pay-earn-section">
            <!-- FB in-app browser + Android + autoOutside=0：手动跳 Chrome -->
            <div class="pay-earn-item" v-if="isFbBrowser && isAndroidDevice && String(autoOutside) === '0'" @click="openInBrowser2">
                <div class="earn-browser-icon">🌐</div>
                <div class="earn-info">
                    <span class="pay-earn-name">{{ $t('common.open_browser_tip') }}</span>
                </div>
                <span class="earn-unlock-btn">Go</span>
            </div>
            <!-- FB in-app browser + iOS + autoOutside=0：手动跳 Safari -->
            <div class="pay-earn-item"  v-if="isFbBrowser && isIosDevice && String(autoOutside) === '0'" @click="openInBrowser3">
                <div class="earn-browser-icon">🌐</div>
                <div class="earn-info">
                    <span class="pay-earn-name">{{ $t('common.open_browser_tip') }}</span>
                </div>
                <span class="earn-unlock-btn">Go</span>
            </div>
            <!-- 看广告 -->
            <!-- <div class="pay-earn-item" @click="watchVideo">
                <div class="earn-ad-badge earn-ad-badge--video">AD</div>
                <div class="earn-info">
                    <span class="pay-earn-name">{{ $t('common.welfare_watch_video_desc') }}</span>
                    <span class="pay-earn-stats" v-if="welfareConfig.watch_video_times > 0">
                        ({{ welfareConfig.watch_video_today_count || 0 }}/{{ welfareConfig.watch_video_daily_limit || welfareConfig.watch_video_times }})
                        +{{ welfareConfig.watch_video_coin }}
                        <img src="../../assets/images/bookbean_icon.png" class="earn-bean-icon"/>
                    </span>
                    <span class="pay-earn-stats pay-earn-stats--disabled" v-else>{{ $t('common.welfare_watch_video_full') }}</span>
                </div>
                <span class="earn-unlock-btn">{{ $t('common.welfare_free_unlock') }}</span>
            </div> -->
            <!-- 访问网站 -->
            <div class="pay-earn-item" @click="visitSite">
                <div class="earn-ad-badge earn-ad-badge--article">AD</div>
                <div class="earn-info">
                    <span class="pay-earn-name">{{ $t('common.welfare_visit_site_desc') }}</span>
                    <span class="pay-earn-stats" v-if="visitCountdown < 0">+200
                        <img src="../../assets/images/bookbean_icon.png" class="earn-bean-icon"/>
                    </span>
                    <span class="pay-earn-stats pay-earn-stats--timer" v-else-if="visitCountdown > 0">
                        {{ $t('common.welfare_visit_site_timer', [visitCountdown]) }}
                    </span>
                    <span class="pay-earn-stats pay-earn-stats--timer" v-else>...</span>
                </div>
                <span class="earn-unlock-btn">{{ $t('common.welfare_free_unlock') }}</span>
            </div>
        </div>

        <!-- 访问网站奖励弹窗 -->
        <van-dialog v-model="visitRewardDialog" :title="$t('common.welfare_beans')" confirm-button-text="OK" @confirm="visitRewardDialog = false; $emit('close')">
            <p style="text-align:center;padding:30px 0;font-size:32px;color:#FCAD0F;font-weight:bold;">+200 {{ $t('common.welfare_beans') }}</p>
        </van-dialog>

        <!-- 支付功能暂时隐藏
        <div class="pay_top">
            <p class="pay_top_title">{{ $t('common.reading_pay_order') }}</p>
        </div>
        <div class="pay_center">
            <p><img :src="chapterList.coverpic" alt="" class="book_img"></p>
            <div class="pay_center_right">
                <div class="pay_center_list active">
                    <p class="title">{{chapterList.title}}{{chapterList.title}}</p>
                    <p class="free">
                        {{readList.coin}}<img src="../../assets/images/bookbean_icon.png" alt="" class="bookbean_icon"/>{{ $t('common.reading_per_chapter') }}
                    </p>
                </div>
                <div class="pay_center_list">
                    <p class="subtitle">{{readList.title}}</p>
                    <p class="right_subtitle" @click="payList">{{ $t('common.reading_buy_chapter') }}</p>
                </div>
            </div>
        </div>
        <p class="vip_free">
            {{ $t('common.reading_vip_free_before') }}<span>{{ $t('common.free') }}</span>{{ $t('common.reading_vip_free_after') }}
        </p>
        <div class="pay_list">
            <p class="pay_button" @click="buttonClick">
                {{ $t('common.reading_open_vip') }}
            </p>
            <p class="pay_button" @click="topupClick">
                {{ $t('common.reading_topup_beans') }}
            </p>
        </div>
        -->
    </div>
</template>

<script>
    import { isFbBrowser, isIosDevice, isAndroidDevice, openInChrome, openInChromeAndroid, openInSafari, getAutoOutside } from '@/utils/browser'

    export default {
        props: {
            chapterList: Object,
            readList: Object,
            welfareConfig: { type: Object, default: () => ({}) },
        },
        name: "Pay",
        data() {
            return {
                visitCountdown: -1,
                visitTimer: null,
                visitSiteRemaining: 0,
                visitRewardDialog: false,
                isFbBrowser: isFbBrowser(),
                isIosDevice: isIosDevice(),
                isAndroidDevice: isAndroidDevice(),
                autoOutside: null,
            }
        },
        watch: {
            welfareConfig: {
                immediate: true,
                handler(val) {
                    if (val && val.visit_site_config) {
                        this.visitSiteRemaining = val.visit_site_config.remaining || 0
                    }
                }
            }
        },
        created() {
            this.autoOutside = getAutoOutside(this.$route && this.$route.query)

            const start = localStorage.getItem('visit_site_start')
            if (start) {
                const elapsed = Date.now() - parseInt(start)
                localStorage.removeItem('visit_site_start')
                if (elapsed >= 20000) {
                    this.$nextTick(() => this.claimVisitReward())
                } else {
                    // 不足20s回来（如微信跳转后返回），提示重新阅读
                    this.$nextTick(() => this.$toast(this.$t('common.welfare_visit_site_too_short')))
                }
            }
            document.addEventListener('visibilitychange', this._onVisibilityChange)
        },
        beforeDestroy() {
            if (this.visitTimer) clearInterval(this.visitTimer)
            document.removeEventListener('visibilitychange', this._onVisibilityChange)
        },
        methods: {
            buttonClick() {
                this.$emit('buttonClick')
            },
            topupClick() {
                this.$emit('topupClick')
            },
            payList() {
                this.$emit('payList')
            },
            goWelfare() {
                this.$emit('close')
                this.$router.push('/welfare')
            },
            openInBrowser2() { openInChromeAndroid() },
            openInBrowser3() { openInSafari() },
            watchVideo() {
                if (!this.welfareConfig.watch_video_times) return
                this.$axios.post('/api/ad/receive_coin')
                    .then(res => {
                        this.$toast('+' + this.welfareConfig.watch_video_coin + ' ' + this.$t('common.welfare_beans'))
                        this.$emit('reward-claimed', res.data.data)
                    })
                    .catch(err => {
                        this.$toast(err.response && err.response.data && err.response.data.message)
                    })
            },
            visitSite() {
                if (this.visitCountdown >= 0) return
                const url = this.welfareConfig.visit_site_config && this.welfareConfig.visit_site_config.url
                if (!url) return
                if (this.isFbBrowser) {
                    // FB browser：先触发跳转弹框，等页面真正隐藏（用户点了 Open）再开始计时
                    // 若用户点 Cancel，页面从未隐藏，不开始计时，按钮保持可点击
                    if (this.isIosDevice) {
                        openInSafari(url)
                    } else {
                        openInChromeAndroid(url)
                    }
                    const onLeave = () => {
                        if (!document.hidden) return
                        document.removeEventListener('visibilitychange', onLeave)
                        clearTimeout(dialogTimeout)
                        localStorage.setItem('visit_site_start', Date.now())
                        this.visitCountdown = 20
                        this._startCountdownTimer()
                    }
                    document.addEventListener('visibilitychange', onLeave)
                    // 30s 内未离开（用户点 Cancel 或忽略弹框），清理监听
                    const dialogTimeout = setTimeout(() => {
                        document.removeEventListener('visibilitychange', onLeave)
                    }, 30000)
                } else {
                    // 非 FB browser：先设置状态再打开URL，避免 visibilitychange 在 window.open
                    // 期间触发时 visitTimer 尚未赋值
                    localStorage.setItem('visit_site_start', Date.now())
                    this.visitCountdown = 20
                    this._startCountdownTimer()
                    try {
                        const w = window.open(url, '_blank')
                        if (!w) window.location.href = url
                    } catch (e) {
                        window.location.href = url
                    }
                }
            },
            _startCountdownTimer() {
                if (this.visitTimer) clearInterval(this.visitTimer)
                this.visitTimer = setInterval(() => {
                    // 若已被外部重置（如提前切回），停止并退出，不覆盖 visitCountdown
                    if (this.visitCountdown <= 0) {
                        clearInterval(this.visitTimer)
                        this.visitTimer = null
                        return
                    }
                    this.visitCountdown--
                    if (this.visitCountdown <= 0) {
                        clearInterval(this.visitTimer)
                        this.visitTimer = null
                        this.visitCountdown = 0
                    }
                }, 1000)
            },
            _onVisibilityChange() {
                if (document.hidden) return
                // 只有本组件启动了倒计时才处理，防止与其他同时挂载的组件竞争 localStorage
                if (this.visitCountdown < 0) return
                const start = localStorage.getItem('visit_site_start')
                if (!start) return
                const elapsed = Date.now() - parseInt(start)
                if (this.visitTimer) clearInterval(this.visitTimer)
                localStorage.removeItem('visit_site_start')
                if (elapsed >= 20000) {
                    // 停留时长足够，自动领取
                    this.claimVisitReward()
                } else {
                    // 提前切回，取消并提示
                    this.visitCountdown = -1
                    this.$toast(this.$t('common.welfare_visit_site_too_short'))
                }
            },
            claimVisitReward() {
                this.$axios.post('/api/welfare/visit_site')
                    .then(res => {
                        this.visitCountdown = -1
                        this.visitRewardDialog = true
                        this.$emit('reward-claimed', res.data.data)
                    })
                    .catch(err => {
                        this.$toast(err.response && err.response.data && err.response.data.message)
                        this.visitCountdown = -1
                    })
            },
        }
    }
</script>

<style scoped>

    .free {
        color: #fff;
        font-size: 20px;
        background: #4d77fd7d;
        padding: 5px 10px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pay_list {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .pay_list > p {
        width: 50%;
    }

    .pay_button {
        background: linear-gradient(135deg, rgba(250, 227, 181, 1) 0%, rgba(246, 211, 151, 1) 100%);
        border-radius: 44px;
        padding: 28px;
        text-align: center;
        font-size: 32px;
        color: #564523;
        margin: 40px;
    }

    .vip_free_text {
        color: #909399;
        font-size: 28px;
    }

    .bookbean_icon {
        width: 15px;
        height: 15px;
        display: inline-block;
        margin: 0 2px;
    }

    .vip_free_text > span {
        text-decoration: line-through;
    }

    .vip_free {
        text-align: center;
        font-size: 38px;
        font-style: oblique;
        font-weight: bold;
        padding: 30px 0;
    }

    .vip_free > span {
        color: #FCAD0F;
    }

    .vip_free > img {
        width: 251px;
        height: 35px;
        display: inline-block;
        margin-bottom: 40px;
    }

    .active {
        margin-bottom: 40px;
    }

    .pay_center_right {
        width: 100%;
    }

    .right_subtitle {
        color: #FCAD0F;
        font-size: 30px;
    }

    .right_title {
        font-size: 32px;
        color: #606266;
    }

    .subtitle {
        font-size: 30px;
        color: #606266;
        width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .title {
        font-size: 32px;
        color: #0A1C33;
        width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .pay_center_list {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .pay_center {
        padding: 40px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }

    .book_img {
        width: 100px;
        height: 140px;
        display: inline-block;
        background: url("../../assets/images/book_cover_def.png") no-repeat;
        background-size: cover;
        border-radius: 10px;
        margin-right: 20px;
    }

    .pay_top {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 30px 40px;
        font-size: 36px;
        color: #303133;
        border-bottom: 1px solid #ECECEC;
    }

    .pay-balance-bar {
        display: flex;
        align-items: center;
        padding: 28px 40px 20px;
        font-size: 26px;
        color: #606266;
        gap: 24px;
    }
    .pay-balance-item {
        display: flex;
        align-items: center;
        gap: 6px;
    }
    .pay-balance-item--low .pay-balance-value {
        color: #F56C6C;
        font-weight: bold;
    }
    .pay-balance-label { color: #909399; }
    .pay-balance-value { color: #303133; font-weight: bold; }
    .pay-balance-divider { color: #dcdfe6; }
    .pay-balance-icon { width: 20px; height: 20px; display: inline-block; vertical-align: middle; margin: 0 2px; }

    .pay-earn-section {
        padding: 60px 40px 0;
        border-bottom: 1px solid #f5f5f5;
        margin-bottom: 4px;
    }
    .pay-earn-item {
        display: flex; align-items: center;
        padding: 24px 0;
        border-bottom: 1px solid #f5f5f5;
        cursor: pointer;
    }
    .pay-earn-item:last-child { border-bottom: none; }
    .earn-browser-icon {
        flex-shrink: 0;
        width: 44px; height: 44px;
        display: flex; align-items: center; justify-content: center;
        font-size: 32px;
        margin-right: 20px;
    }
    .earn-ad-badge {
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid #FF69B4;
        display: flex; align-items: center; justify-content: center;
        font-size: 20px; font-weight: bold; color: #FF69B4;
        padding: 4px 10px;
        margin-right: 20px; letter-spacing: 1px;
        background: transparent;
    }
    .earn-ad-badge--video, .earn-ad-badge--article {}
    .earn-info { flex: 1; display: flex; flex-direction: column; gap: 6px; }
    .earn-unlock-btn {
        flex-shrink: 0;
        background: linear-gradient(90deg, #4D77FD, #7797FF);
        color: #fff; font-size: 28px; font-weight: bold;
        padding: 18px 32px; border-radius: 30px;
        white-space: nowrap; margin-left: 16px;
    }
    .pay-earn-name { font-size: 26px; color: #303133; line-height: 1.4; }
    .pay-earn-stats { font-size: 22px; color: #FCAD0F; }
    .pay-earn-stats--disabled { color: #bfc2cc; }
    .pay-earn-stats--timer { color: #4D77FD; }
    .earn-bean-icon { width: 20px; height: 20px; display: inline-block; vertical-align: middle; margin: 0 2px; }

</style>